/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { FC, useEffect, useState } from "react";
import { Button, Spinner, Tooltip } from "@fluentui/react-components";
import { ResourceAllowOrderForm } from "./Models";
import { ResourceInfo } from "@/services";
import { useTranslation } from "react-i18next";
import { IResourceStore } from "@/redux/slices/resources/ResourceReducerModel";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "@/redux";
import { AttendeeInfo } from "@/services/attendee-service/entity/AttendeeEntity";
import { ISettingStore } from "@/redux/slices/settings/SettingModel";
import { IOrganizationStore } from "@/redux/slices/organizations/OrganizationModel";
import { OrderDataRequest } from "@/services/rc-resource-service/entity/OrderDataRequest";
import { setLoading } from "@/redux/slices/loading/LoadingSlice";
import axios from "axios";
import { useQuery } from "@tanstack/react-query";
import { RcResourceService } from "@/services/rc-resource-service";
// import { Tooltip } from "@fluentui/react/lib/Tooltip";
// import { useLanguage } from "@resource-finder/ui/until";
// import { ResourceAllowOrderForm } from "@resource-finder/index";
// import { RCAttributeBuilder } from "@shared/index";
// import { BaseResource } from "@resource-finder/domain/classes";
export interface OrderFormProps {
  statusAllowOrderForm?: (resource: ResourceInfo, originalSelectedResources: ResourceInfo[]) => ResourceAllowOrderForm;
  IsMoveOrder?: (request: OrderDataRequest, currentResource: ResourceInfo, selectedResource: ResourceInfo[], originalSelectedResources: ResourceInfo[]) => Promise<boolean>;
  IsBookingExistsOrder?: () => boolean;
  OnPlaceOrder?: (
    isMoveOrder: boolean,
    request: OrderDataRequest,
    currentResource: ResourceInfo,
    selectedResource: ResourceInfo[],
    originalSelectedResources: ResourceInfo[],
    attendees: AttendeeInfo[],
    settings: ISettingStore,
    orgStore: IOrganizationStore
  ) => void;
  ContextEnum?: string;
  Resource: ResourceInfo;
}
export const OrderForm: FC<OrderFormProps> = (props: OrderFormProps) => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const loading = useSelector((state: RootState) => state.loading);
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [labelBtn, setLabelBtn] = useState<string>(t("New Order"));
  const [isMoveOrder, setIsMoveOrder] = useState<boolean>(false);
  const statusShow = true;

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const orgStore: IOrganizationStore = useSelector((state: RootState) => state.orgInfo) as IOrganizationStore;

  const resourceStore: IResourceStore = useSelector((state: RootState) => state.resources) as IResourceStore;

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const resources: ResourceInfo[] | null = resourceStore.selectedResource || [];
  const originalSelectedResources: ResourceInfo[] = resourceStore.originalSelectedResources || [];

  const attendees: AttendeeInfo[] = (resourceStore.attendees.mainAttendee ? [resourceStore.attendees.mainAttendee] : []).concat(resourceStore?.attendees.listAttendee || []);

  const settingStore: ISettingStore = useSelector((state: RootState) => state.settingInfo) as ISettingStore;

  useEffect(() => {
    const checkOrder = async () => {
      dispatch(setLoading(true));
      if ((props?.Resource?.orders?.guid && props?.Resource?.orders?.haveNormalOrder) || resourceStore.resourceProcessingMoving?.find((resource) => resource.guid === props?.Resource?.guid)) {
        setLabelBtn(t("Change Order"));
        setIsMoveOrder(false);
      }
      if (
        resourceStore.selectedResource?.length &&
        resourceStore.selectedResource?.length > 1 &&
        !resourceStore.resourceProcessingMoving?.find((resource) => resource.guid === props?.Resource?.guid)
      ) {
        if (labelBtn === t("Move Order")) {
          setLabelBtn(t("New Order"));
          setIsMoveOrder(false);
        }
      }
      if (
        resources?.length === 1 &&
        originalSelectedResources.length === 1 &&
        originalSelectedResources[0].orders?.haveNormalOrder &&
        !resourceStore.resourceProcessingMoving?.find((resource) => resource.guid === props?.Resource?.guid)
      ) {
        if (resources[0]?.guid !== originalSelectedResources[0]?.guid) {
          const payload: OrderDataRequest = {
            BaseUrl: orgStore.orgInfo?.resourceCentralEndpoint + "/ResourceCentral/api/OfficeApp/CheckExtenalResourcesSuitableForMovingOrder",
            Payload: {
              ResourceAdId: props.Resource.adId,
              OldGuid: originalSelectedResources[0].orders?.guid || "",
              OrganizerEmail: orgStore.organizer?.email || "",
              StartTime: orgStore.outlookInfo?.startTimeTicks || 0,
              EndTime: orgStore.outlookInfo?.endTimeTicks || 0,
              TimeZoneName: orgStore.organizer?.timeZone || "",
            },
          };
          if (props?.IsMoveOrder && (await props.IsMoveOrder(payload, props.Resource, resources, originalSelectedResources))) {
            setLabelBtn(t("Move Order"));
            setIsMoveOrder(true);
          }
        }
      }
      dispatch(setLoading(false));
    };

    checkOrder(); // Call the async function
  }, [props, resourceStore]);

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const handlePlaceOrder = (e: React.MouseEvent<HTMLElement>) => {
    const payload: OrderDataRequest = {
      BaseUrl: orgStore.orgInfo?.resourceCentralEndpoint + "/ResourceCentral/api/OfficeApp/CheckExtenalResourcesSuitableForMovingOrder",
      Payload: {
        ResourceAdId: props.Resource.adId,
        OldGuid: originalSelectedResources.length > 0 ? originalSelectedResources[0].orders?.guid || "" : "",
        OrganizerEmail: orgStore.organizer?.email || "",
        StartTime: orgStore.outlookInfo?.startTimeTicks || 0,
        EndTime: orgStore.outlookInfo?.endTimeTicks || 0,
        TimeZoneName: orgStore.organizer?.timeZone || "",
      },
    };
    props?.OnPlaceOrder && props?.OnPlaceOrder(isMoveOrder, payload, props.Resource, resources || [], originalSelectedResources || [], attendees || [], settingStore, orgStore);
  };



  const buildOrderForm = () => {
    const { statusAllowOrderForm, Resource } = props; // Destructure from props
    const orderStatus = statusAllowOrderForm ? statusAllowOrderForm(Resource, originalSelectedResources) : null; // Call the function with appropriate arguments
    switch (
    orderStatus // Use the result of the function call
    ) {
      case ResourceAllowOrderForm.Allow:
        return statusShow ? (
          <Tooltip content={labelBtn} relationship="label">
            <Button
              onClick={handlePlaceOrder}
              style={{
                display: "flex",
                fontWeight: 600,
                padding: "0px",
                width: "100%",
                fontSize: "10px",
                height: "16px",
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
                fontFamily: '"Segoe UI", "Segoe UI Web (West European)", "Segoe UI", -apple-system, BlinkMacSystemFont, Roboto, "Helvetica Neue",                 sans-serif !important',
              }}
              appearance="primary"
              size="small"
            >
              {labelBtn}
            </Button>
          </Tooltip>
        ) : null;
      case ResourceAllowOrderForm.IsRecurring:
        return statusShow ? (
          <Tooltip
            relationship="label"
            content={t(
              "As this is a Recurring meeting, please use 'My Meetings', the individual Outlook meeting of the series or the Recurring reservation or order email to handle the orders for this series."
            )}
          >
            <Button
              onClick={handlePlaceOrder}
              style={{
                display: "flex",
                fontWeight: 600,
                padding: "0px",
                width: "100%",
                fontSize: "10px",
                height: "16px",
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
                fontFamily: '"Segoe UI", "Segoe UI Web (West European)", "Segoe UI", -apple-system, BlinkMacSystemFont, Roboto, "Helvetica Neue",                 sans-serif !important',
              }}
              appearance="primary"
              size="small"
              disabled
            >
              {labelBtn}
            </Button>
          </Tooltip>
        ) : null;
      case ResourceAllowOrderForm.ChildVR:
        return statusShow ? (
          <Tooltip relationship="label" content={t("The order for this resource cannot be updated because it belongs to a virtual resource.")}>
            <Button
              style={{
                display: "flex",
                fontWeight: 600,
                padding: "0px",
                opacity: 0.5,
                cursor: "default",
                border: "1px solid #a5a3a6!important",
                width: "100%",
                fontSize: "10px",
                height: "16px",
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
                fontFamily: '"Segoe UI", "Segoe UI Web (West European)", "Segoe UI", -apple-system, BlinkMacSystemFont, Roboto, "Helvetica Neue",                 sans-serif !important',
              }}
              appearance="primary"
              size="small"
              disabled
            >
              {labelBtn}
            </Button>
          </Tooltip>
        ) : null;
      case ResourceAllowOrderForm.LightResource:
        return statusShow ? (
          <Tooltip content={t("It is not possible to order services on the selected resource.")} relationship="label">
            <Button
              style={{
                display: "flex",
                fontWeight: 600,
                padding: "0px",
                opacity: 0.5,
                cursor: "default",
                border: "1px solid #a5a3a6!important",
                width: "100%",
                fontSize: "10px",
                height: "16px",
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
                fontFamily: '"Segoe UI", "Segoe UI Web (West European)", "Segoe UI", -apple-system, BlinkMacSystemFont, Roboto, "Helvetica Neue",                 sans-serif !important',
              }}
              appearance="primary"
              size="small"
              disabled
            >
              {labelBtn}
            </Button>
          </Tooltip>
        ) : null;
      case ResourceAllowOrderForm.Workspace:
        return statusShow ? (
          <Tooltip content={t("It is not possible to order services on the selected resource.")} relationship="label">
            <Button
              style={{
                display: "flex",
                fontWeight: 600,
                padding: "0px",
                opacity: 0.5,
                cursor: "default",
                border: "1px solid #a5a3a6!important",
                width: "100%",
                fontSize: "10px",
                height: "16px",
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
                fontFamily: '"Segoe UI", "Segoe UI Web (West European)", "Segoe UI", -apple-system, BlinkMacSystemFont, Roboto, "Helvetica Neue",                 sans-serif !important',
              }}
              appearance="primary"
              size="small"
              disabled
            >
              {labelBtn}
            </Button>
          </Tooltip>
        ) : null;
      case ResourceAllowOrderForm.DifferentSOF:
        return statusShow ? (
          <Tooltip content={t("Order cannot be placed because selected resources do not have the same Shared Order Form.")} relationship="label">
            <Button
              style={{
                display: "flex",
                fontWeight: 600,
                padding: "0px",
                opacity: 0.5,
                cursor: "default",
                border: "1px solid #a5a3a6 !important",
                width: "100%",
                fontSize: "10px",
                height: "16px",
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
                fontFamily: '"Segoe UI", "Segoe UI Web (West European)", "Segoe UI", -apple-system, BlinkMacSystemFont, Roboto, "Helvetica Neue", sans-serif !important',
              }}
              appearance="primary"
              size="small"
            >
              {labelBtn}
            </Button>
          </Tooltip>
        ) : null;
      default:
        break;
    }
  };

  const fetchCheckResource = async () => {
    const rcResourceService = new RcResourceService();
    const payload: OrderDataRequest = {
      BaseUrl: orgStore.orgInfo?.resourceCentralEndpoint + "/ResourceCentral/api/OfficeApp/GetResourceLicenseTypeByAdId",
      Payload: {
        ResourceAdId: props.Resource.adId,
      },
    };
    const response = await rcResourceService.fetchCheckResource(payload);
    return response.data;
  };

  const { data, error, isLoading } = useQuery({
    queryKey: ['checkResource'],
    queryFn: fetchCheckResource,
    staleTime: 1000 * 60 * 5, // Cache for 5 minutes
  });



  return (
    <>
      {" "}
      {loading && isLoading ? (
        <>
          <Spinner size="tiny" />
        </>
      ) : (
        <>
          {data ? (
            <>
              <Tooltip content={t("Disabled resource light or workspace")} relationship="label">
                <Button
                  style={{
                    display: "flex",
                    fontWeight: 600,
                    padding: "0px",
                    opacity: 0.5,
                    cursor: "not-allowed",
                    border: "1px solid #a5a3a6 !important",
                    width: "100%",
                    fontSize: "10px",
                    height: "16px",
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    fontFamily: '"Segoe UI", "Segoe UI Web (West European)", "Segoe UI", -apple-system, BlinkMacSystemFont, Roboto, "Helvetica Neue", sans-serif !important',
                  }}
                  appearance="primary"
                  size="small"
                  disabled
                >
                  {labelBtn}
                </Button>
              </Tooltip>
            </>
          ) : (
            buildOrderForm()
          )}
        </>
      )}
    </>
  );
};
